import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import NoRecords from '../../util/noRecords';
import '../../styles/devices.css';

class TerminalList extends Component {
    constructor(props) {
        super(props);
    }

    onDetails(terminal, event) {
        event.preventDefault();
        browserHistory.push(`terminals/${terminal.terminalID}`);
    }

    render() {
        return (
            <div>
                <h3 className="client-text">Terminals</h3>
                {this.props.terminalList && this.props.terminalList.length > 0 ?
                    <div>
                        {this.props.terminalList.map(function(terminal) {
                            return (
                                <div className="card-slim" key={terminal.terminalID} onClick={this.onDetails.bind(this, terminal)}>
                                    <h3 className="m-t-0 m-b-5 text-center">{terminal.terminalID}</h3>
                                    <div className={"device " + (terminal.model || "").toLowerCase()} />
                                    <table className="table table-striped m-t-10 m-b-0">
                                        <tbody>
                                            <tr>
                                                <th>Make</th>
                                                <td>{terminal.maker}</td>
                                            </tr>
                                            <tr>
                                                <th>Model</th>
                                                <td>{terminal.model}</td>
                                            </tr>
                                            <tr>
                                                <th>Serial No.</th>
                                                <td>{terminal.serial.trim()}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }.bind(this))}
                    </div>
                    :
                    <NoRecords type="Terminals" />
                }
            </div>
        );
    }
}

export default TerminalList;


// WEBPACK FOOTER //
// ./app/terminals/components/terminalList.js